/**
 * Copies each found value onto the form where the owner left the field as it was last filled, and
 * records it as the new fill. A field the owner changed keeps their value.
 */
export function fillUntouchedFields<T extends object>(fields: T, lastFilled: T, found: Partial<T>): void {
  for (const key of Object.keys(found) as (keyof T)[]) {
    const value = found[key];

    if (value != null && fields[key] === lastFilled[key]) {
      fields[key] = value as T[keyof T];
      lastFilled[key] = value as T[keyof T];
    }
  }
}
